import { extendTheme, createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { inputAnatomy } from '@chakra-ui/anatomy';
import '@fontsource-variable/inter';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(inputAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    color: 'gray.600',
  },
});
const inputTheme = defineMultiStyleConfig({ baseStyle });

const theme = extendTheme(
  {
    components: { Input: inputTheme },
    fonts: {
      body: '\'Inter Variable\', sans-serif',
    },
    styles: {
      global: {
        'html, body': {
          bgColor: 'gray.50',
          color: '#3B3B3B',
        },
      },
    },
    zIndices: {
      modal: 1300,
    },
  },
);

export default theme;
